import Vue from "vue";
import AppointmentPaymentDialogContent from "./AppointmentPaymentDialogContent.vue";
export default Vue.extend({
    data() {
        return {
            animationSettings: { effect: "None" },
            contentTemplate: function () {
                return {
                    template: AppointmentPaymentDialogContent
                };
            }
        };
    },
    methods: {
        show(args) {
            // The content loads the payments of the appointment before the dialog is shown
            this.$emit("show", args);
            this.$refs.appointmentPaymentDialog.show();
        },
        hide() {
            this.$refs.appointmentPaymentDialog.hide();
        }
    }
});
